"use client";

import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Legacy Layout component - now just passes through children
 * Header/Footer are now in PersistentLayout at root level
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return <>{children}</>;
};

export { Layout };